import React from "react"
import Icon from "@app/components/Icon"
import { BoxProps } from "@chakra-ui/react"

type Props = {
  color?: string
  filled: boolean
} & BoxProps

const WishlistIcon: React.FC<Props> = ({ color, filled, ...props }) => (
  <Icon
    name="heart"
    width="48px"
    height="48px"
    p={3.5}
    color={filled ? "preset.red" : color || "primary.midGrey"}
    fill={filled ? "preset.red" : "transparent"}
    sx={{
      "@media (hover: hover) and (pointer: fine)": {
        "&:hover": { fill: "preset.red", color: "preset.red" },
      },
      "@media (hover: hover) and (pointer: coarse)": {
        "&:hover": { fill: "preset.red", color: "preset.red" },
      },
    }}
    {...props}
  />
)

export default React.memo(WishlistIcon)
